// extracted by mini-css-extract-plugin
export default {"panel":"BuffStatusControls_panel__xWZUk","toggle":"BuffStatusControls_toggle__Kg2qa","body":"BuffStatusControls_body__DZ9HW"};